import { Dialog, Stack, useTheme } from '@mui/material';

import { Header } from '@app/sections/header';

interface CommonDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  backgroundImage?: string;
  backgroundOpacity?: number;
  blurRadius?: number;
  boardIcon?: string | undefined;
  height?: string;
  width?: string;
  fullWidth?: boolean;
  sx?: object;
  padding?: number;
}

const GlassEffectDialog = ({
  open,
  onClose,
  title,
  children,
  backgroundImage,
  backgroundOpacity = 0.5,
  blurRadius = 9,
  padding = 2,
  boardIcon,
  height,
  width,
  fullWidth,
  sx = {},
}: CommonDialogProps) => {
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onClose} sx={{ scrollbarWidth: 'none' }}>
      <Stack
        sx={{
          overflowY: 'scroll',
          scrollbarWidth: 'none',
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
        }}
      >
        <Stack
          sx={{
            backgroundColor: `rgba(255, 255, 255, ${backgroundOpacity})`,
            backdropFilter: `blur(${blurRadius}px)`,
            height: '100%',
          }}
        >
          {title && (
            <Header
              title={title}
              leftIcon={boardIcon}
              onClose={onClose}
              titleStyle={{ color: theme.palette.taskboard.raisinBlack }}
            />
          )}
          <Stack sx={{ padding }}>{children}</Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default GlassEffectDialog;
